import { formatMoney } from 'utils/storefront/format-resource';

document.querySelectorAll('[data-price]').forEach((el) => {
  // eslint-disable-next-line no-param-reassign
  el.textContent = formatMoney({ amount: el.dataset.price }, true);
});
